import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router";
import { trackClick } from "../../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../../hooks/useScreenTracking";
import SearchEmptyImage from "../../../assets/empty-search.png";

import {
  EmptySearchWrap,
  EmptySearchContent,
  EmptySearchImg,
  EmptySearchTitle,
  EmptySearchButton,
} from "../styles";

export default function SearchEmptyState({ searchTerm }) {
  const navigate = useNavigate();
  const screenName = useScreenTracking();

  const handleGoToHome = () => {
    trackClick({
      title: "ir-para-a-home",
      contentType: "busca",
      screenName,
      tagId: tagIdFromLegacySuffix("01"),
    });
    navigate("/loja");
  };

  return (
    <EmptySearchWrap data-search-term={searchTerm || undefined}>
      <EmptySearchContent>
        <EmptySearchImg
          src={SearchEmptyImage}
          alt="Sacola de compras"
        />
        <EmptySearchTitle>
          Não encontramos resultados
          <br />
          para o termo buscado.
        </EmptySearchTitle>
      </EmptySearchContent>
      <EmptySearchButton
        className="btn-default-wl btn btn-primary text-xs"
        onClick={handleGoToHome}
        type="button"
      >
        IR PARA A HOME
      </EmptySearchButton>
    </EmptySearchWrap>
  );
}

SearchEmptyState.propTypes = {
  searchTerm: PropTypes.string,
};
